import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Planification from './pages/Planification/Planification';
import BilanEquipe from './pages/BilanEquipe/BilanEquipe';
import StatutProjets from './pages/StatutProjets/StatutProjets';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import { PlanificationProvider } from './context/PlanificationContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <PlanificationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>}>
                <Route index element={<Navigate to="/planification" replace />} />
                <Route path="planification" element={<Planification />} />
                <Route path="bilan-equipe" element={<BilanEquipe />} />
                <Route path="statut-projets" element={<StatutProjets />} />
              </Route>
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </PlanificationProvider>
    </AuthProvider>
  );
}

export default App;
